import green from './green.json';
import gold from './gold.json';
import platinum from './platinum.json';
import bmw from './bmw.json';
import blue from './blue.json';
import payback from './payback.json';
import dmPayback from './dm-payback.json';
import bmwPremium from './bmw-premium.json';
import bmwSillver from './bmw-silver.json';
import bmwGold from './bmw-gold.json';
import mini from './mini.json';
import sixt from './sixt.json';
import sixtGold from './sixt-gold.json';
import bmwBlue from './bmw-blue.json';
import goldPlastic from './gold-plastic.json';

export {
  green,
  gold,
  platinum,
  blue,
  payback,
  dmPayback,
  bmw,
  bmwPremium,
  bmwSillver,
  bmwGold,
  mini,
  sixt,
  sixtGold,
  bmwBlue,
  goldPlastic,
};
